import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * «A new version is ready» (#303, part 2), in the band under the header where the shell's other
 * notice sits (`FirstLoadNotice`), with the same look.
 *
 * The update is the person's choice, never automatic: a reload under a half-filled form would lose
 * it. «Aggiorna» reloads; the cross hides the band until the next load, which then runs the new
 * version anyway. `role="status"` announces it once without moving the focus.
 */
export function NewVersionNotice({ available }: { available: boolean }) {
  const { t } = useTranslation(['shell', 'common']);
  const [dismissed, setDismissed] = useState(false);

  if (!available || dismissed) {
    return null;
  }

  return (
    <div
      role="status"
      className="border-border bg-accent text-accent-foreground flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b px-[clamp(16px,2.4vw,24px)] py-2 text-sm print:hidden"
    >
      <p className="m-0">{t('shell:newVersion.text')}</p>
      <div className="flex items-center gap-1">
        <Button type="button" variant="outline" size="sm" onClick={() => window.location.reload()}>
          <RefreshCw aria-hidden="true" />
          {t('shell:newVersion.reload')}
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={t('common:dismiss')}
          onClick={() => setDismissed(true)}
        >
          <X aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}
